import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist/legacy/build/pdf';

// Set the worker URL for pdfjsLib.
// IMPORTANT: load the worker from our own /public folder so the worker version
// is always in lockstep with the pdfjs-dist API version we ship. A pinned CDN
// URL here will drift away from the installed `pdfjs-dist` on the next
// `npm install` and cause an "API/Worker version mismatch" runtime error.
// See: docs/operations/pdfjs-worker.md and the fix/pdfjs-worker-version-sync PR.
GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdf.worker.min.js`;

/**
 * Fetches metadata from a PDF file located at the given URL.
 * @param {string} pdfUrl - The URL of the PDF file.
 * @returns {Promise<Object>} A promise that resolves to the metadata object, or null if an error occurs.
 */
export const getPDFMetadata = async (pdfUrl) => {
  try {
    // Load the PDF document
    const loadingTask = getDocument(pdfUrl);
    const pdfDocument = await loadingTask.promise;

    // Get the metadata
    const metadata = await pdfDocument.getMetadata();
    return metadata;
  } catch (error) {
    console.error('Error getting PDF metadata:', error);
    return null;
  }
};
